import React, { createContext, useContext, useState, ReactNode } from 'react'

interface DateRange {
  start: string  // YYYY-MM-DD
  end: string    // YYYY-MM-DD
}

interface FiscalWeekContextType {
  selectedFiscalWeek: number | undefined
  setSelectedFiscalWeek: (week: number | undefined) => void
  selectedDateRange: DateRange | null
  setSelectedDateRange: (range: DateRange | null) => void
}

const FiscalWeekContext = createContext<FiscalWeekContextType | undefined>(undefined)

export function FiscalWeekProvider({ children }: { children: ReactNode }) {
  const [selectedFiscalWeek, setSelectedFiscalWeek] = useState<number | undefined>(undefined)
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange | null>(null)

  return (
    <FiscalWeekContext.Provider value={{
      selectedFiscalWeek, setSelectedFiscalWeek,
      selectedDateRange, setSelectedDateRange,
    }}>
      {children}
    </FiscalWeekContext.Provider>
  )
}

export function useFiscalWeekContext() {
  const context = useContext(FiscalWeekContext)
  if (context === undefined) {
    throw new Error('useFiscalWeekContext must be used within a FiscalWeekProvider')
  }
  return context
}
